import { render, staticRenderFns } from "./CartCustomCouponRateType.vue?vue&type=template&id=163d92f3&"
import script from "./CartCustomCouponRateType.vue?vue&type=script&lang=ts&"
export * from "./CartCustomCouponRateType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports